import script from "./LinkThresholdFacilitiesToGroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkThresholdFacilitiesToGroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./LinkThresholdFacilitiesToGroupModal.vue?vue&type=style&index=0&id=64d90071&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d90071"]])

export default __exports__